define('data-transformers/json',['require','exports','module'],function(require,module,exports){
	return function(data, datasource, params) {
		return data && JSON.parse((data.text||data.responseText));
	}
});
